import React from 'react';
import { Apartment } from '@mui/icons-material';
import { Logo, LogoPropsSchema } from './Logo';
import LogoSidebarPanel from './LogoSidebarPanel';
export default {
    label: 'Logo',
    icon: React.createElement(Apartment, null),
    type: 'Logo',
    defaultData: {
        props: {
            logo: 'main',
            logos: {},
            width: null,
            height: null,
        },
        style: {
            backgroundColor: null,
            textAlign: 'left',
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: LogoSidebarPanel,
    Component: Logo,
    schema: LogoPropsSchema,
};
//# sourceMappingURL=index.js.map